import styled from 'styled-components';

export const SectionWrapper = styled.div<{
  oddColor: string;
  evenColor: string;
}>`
  .section {
    :nth-of-type(even) {
      background: ${props => props.evenColor};
    }
    :nth-of-type(odd) {
      background: ${props => props.oddColor};
    }
  }
`;
